import { Link } from 'foundations-components/transitional/components/Link';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getVariantsEditorUrl } from 'personalization-lib/utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
const ManageVariantsLink = ({
  strategyId
}) => /*#__PURE__*/_jsx(Link, {
  href: getVariantsEditorUrl(strategyId),
  external: true,
  children: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "personalizationLib.shared.manageVariants"
  })
});
export default ManageVariantsLink;